const SPECIAL_HEADERS_COUNT = 2;
const THEMES_LIST_SPECIAL_HEADERS_COUNT = 1;

export {
  SPECIAL_HEADERS_COUNT,
  THEMES_LIST_SPECIAL_HEADERS_COUNT
}